/**
 * ZingaBoo — Cart Preview Image Swap
 * Dawn Theme — add to: assets/zingaboo-cart-preview.js
 *
 * Replaces the default product image in the cart with the
 * customer's personalised design preview PNG.
 */

(function() {
    'use strict';

    function swapCartImages() {
        // Dawn theme cart item selectors
        const cartItems = document.querySelectorAll('cart-items .cart-item, .cart-items .cart-item');

        cartItems.forEach(item => {
            // Already swapped — skip
            if (item.dataset.zbSwapped) return;

            // Find the _preview_url property
            // Shopify renders line item properties in hidden inputs or data attributes
            // In Dawn, properties appear in the cart item description area
            let previewUrl = null;

            // Method 1: look for a data attribute Shopify renders
            const propEls = item.querySelectorAll('.product-option');
            propEls.forEach(el => {
                const text = el.textContent || '';
                if (text.includes('_preview_url')) {
                    // Extract URL from "Key: Value" format
                    const match = text.match(/https?:\/\/[^\s]+/);
                    if (match) previewUrl = match[0];
                    // Hide this element — customer shouldn't see internal properties
                    el.style.display = 'none';
                }
                // Also hide _design_token property
                if (text.includes('_design_token')) {
                    el.style.display = 'none';
                }
            });

            // Method 2: check cart item properties via Shopify cart API
            if (!previewUrl) {
                const itemIndex = item.dataset.index || item.querySelector('[data-index]')?.dataset?.index;
                if (itemIndex && window._zbCartData) {
                    const cartItem = window._zbCartData.items?.[parseInt(itemIndex) - 1];
                    if (cartItem?.properties?._preview_url) {
                        previewUrl = cartItem.properties._preview_url;
                    }
                }
            }

            if (previewUrl) {
                // Find the product image in this cart item
                const img = item.querySelector('.cart-item__image img, .cart-item__media img');
                if (img) {
                    img.src     = previewUrl;
                    img.srcset  = previewUrl;
                    img.alt     = 'Your personalised design';
                    img.style.objectFit = 'contain';
                    item.dataset.zbSwapped = '1';
                }
            }
        });
    }

    // Fetch cart data from Shopify API to get properties
    function loadCartAndSwap() {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                window._zbCartData = cart;
                swapCartImages();
            })
            .catch(() => {
                // If cart.js fails, still try DOM-based swap
                swapCartImages();
            });
    }

    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadCartAndSwap);
    } else {
        loadCartAndSwap();
    }

    // Re-run when cart updates (Dawn uses custom elements that re-render)
    const observer = new MutationObserver(() => {
        loadCartAndSwap();
    });

    // Observe the cart items container for changes
    const cartContainer = document.querySelector('cart-items, .cart-items');
    if (cartContainer) {
        observer.observe(cartContainer, { childList: true, subtree: true });
    }

    // Also hide internal properties in order confirmation emails
    // (handled server-side — properties starting with _ are hidden by Dawn automatically)

})();